import { useRef } from 'react';
import styled from 'styled-components';
import { colors } from '@ardoq/design-tokens';
import { useTexture } from './useTexture';
import { Icon, IconSize, ShapeType } from '@ardoq/icons';

const Stadium = styled.div`
  border: 1px solid ${colors.black950};
  border-radius: 8px;
  width: 40px;
  min-width: 40px;
  height: 16px;
  overflow: hidden;
`;

const Rectangle = styled.div`
  position: relative;
  width: 18px;
  min-width: 18px;
  height: 18px;
  overflow: hidden;
  border: 1px solid ${colors.black950};
  border-radius: 3px;
  & > svg {
    width: 16px;
    height: 16px;
  }
`;

type TexturePreviewProps = {
  textureIndex: number;
  shape?: 'STADIUM' | 'RECTANGLE';
};
export const TexturePreview = ({
  textureIndex,
  shape,
}: TexturePreviewProps) => {
  const shapeRef = useRef<HTMLDivElement | null>(null);

  useTexture(shapeRef, textureIndex);

  const Shape = shape === 'RECTANGLE' ? Rectangle : Stadium;

  return (
    <Shape
      ref={shapeRef}
      style={textureIndex === -1 ? { visibility: 'hidden' } : undefined}
    />
  );
};

const LabelWrapper = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: nowrap;
  max-width: 450px;
`;

type GetLabelWithFieldRepresentationArgs = {
  label: string;
  textureIndex: number;
  milestoneIconName?: ShapeType;
};
export const getLabelWithFieldRepresentation = ({
  label,
  textureIndex,
  milestoneIconName,
}: GetLabelWithFieldRepresentationArgs) => (
  <LabelWrapper>
    {milestoneIconName ? (
      <Icon iconName={milestoneIconName} iconSize={IconSize.MEDIUM} />
    ) : (
      <TexturePreview textureIndex={textureIndex} shape="RECTANGLE" />
    )}
    {label}
  </LabelWrapper>
);
